// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"4560c008","884":"8f7dfbfd"}[chunkId] + ".chunk.js";
};